import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        {/* Hero Header */}
        <section className="pt-28 md:pt-32 pb-12 md:pb-16 px-4 md:px-6 lg:px-10 bg-background-100">
          <div className="max-w-7xl mx-auto text-center">
            <span className="inline-block text-xs font-semibold uppercase tracking-wider text-accent-500 border border-accent-200 rounded-full px-3 py-1 mb-4">
              About Us
            </span>
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4">
              About <span className="text-primary-500">Ezzogenics</span>
            </h1>
            <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
              Protecting Singapore since 2012. SCDF-registered, BCA-licensed, and trusted by 850+ commercial and residential properties.
            </p>
          </div>
        </section>

        {/* Story Section */}
        <section className="px-4 md:px-6 lg:px-10 py-12 md:py-16 max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div className="rounded-2xl overflow-hidden h-72 md:h-96">
              <img
                src="https://storage.readdy-site.link/project_files/bad53886-d0ad-4ee3-acb4-5b763a394fe2/99fd3be5-7e59-4e94-a3d8-68dc40ed6056_compressed_Depositphotos_9337610_l-2015.webp"
                alt="Fire safety engineering blueprints and planning documents"
                title="Professional fire safety engineering plans and drawings"
                className="w-full h-full object-cover"
                width="800"
                height="600"
                loading="lazy"
              />
            </div>
            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
                Our Story
              </h2>
              <p className="text-foreground-600 text-base leading-relaxed mb-4">
                Founded in 2012, Ezzogenics began with a simple mission: make every building in Singapore safe from fire hazards. What started as a two-person team has grown into a full-service fire safety company serving over 850 properties across all 28 districts.
              </p>
              <p className="text-foreground-600 text-base leading-relaxed mb-4">
                Our engineers are SCDF-certified and BCA-registered, with specialized expertise in fire risk assessment, alarm systems, suppression systems, and emergency lighting. We have helped countless businesses achieve full SCDF compliance and protect their people and assets.
              </p>
              <p className="text-foreground-600 text-base leading-relaxed">
                Today, we combine cutting-edge technology with decades of hands-on experience to deliver fire safety solutions that are reliable, compliant, and tailored to each client's unique needs.
              </p>
            </div>
          </div>
        </section>

        {/* Values / Certifications */}
        <section className="bg-background-100 py-12 md:py-16">
          <div className="px-4 md:px-6 lg:px-10 max-w-7xl mx-auto">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
              Why Choose <span className="text-primary-500">Us</span>
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
              {[
                { icon: "ri-shield-check-line", title: "SCDF Registered", desc: "Fully registered with Singapore Civil Defence Force for all fire safety services." },
                { icon: "ri-building-line", title: "BCA Licensed", desc: "Licensed by Building and Construction Authority for professional fire safety works." },
                { icon: "ri-award-line", title: "BizSAFE Level 3", desc: "Certified workplace safety and health management system in place." },
                { icon: "ri-customer-service-2-line", title: "24/7 Support", desc: "Emergency response team available around the clock for urgent fire safety issues." },
              ].map((item) => (
                <div key={item.title} className="bg-background-50 rounded-2xl p-6 border border-background-200/70">
                  <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mb-4">
                    <i className={`${item.icon} text-primary-600 text-xl`}></i>
                  </div>
                  <h3 className="font-semibold text-foreground-900 text-base mb-2">{item.title}</h3>
                  <p className="text-foreground-600 text-sm leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="px-4 md:px-6 lg:px-10 py-12 md:py-16 max-w-7xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            Ready to Secure Your Property?
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto mb-6">
            Contact us today for a free consultation or upload your fire safety documents for review.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              Upload Documents
              <i className="ri-upload-cloud-2-line text-lg"></i>
            </Link>
            <a
              href="https://wa.me/6585353868"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border border-foreground-300 text-foreground-700 text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              WhatsApp +65 8535 3868
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}